module.exports = __webpack_public_path__ + "static/media/aam-challenges.9421e7a2.jpg";